// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/** Lazy loader for the NotificationSettingsDialogContainer */ export const NotificationSettingsDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-notificationsettingsdialogcontainer" */ "./NotificationSettingsDialogContainer")).then((module)=>({
            default: module.NotificationSettingsDialogContainer
        }));
/** Lazy loading wrapper for NotificationSettingsDialogContainer */ export const LazyNotificationSettingsDialogContainer = /*#__PURE__*/ lazy(NotificationSettingsDialogContainerLazyLoader);
